import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Textarea } from '../../../../../CommonComponents/OPL/Textarea/Textarea';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormFieldName as FirmFormFieldName } from '../../FirmSettings.meta';
import { FormFieldName as MySettingsFormFieldName } from '../../../MySettings/MySettings.meta';

interface Props extends MarginProps {
  isFirm?: boolean;
  fieldName: FirmFormFieldName | MySettingsFormFieldName;
  formBag: UseFormReturn<any>;
}

export const CustomDisclosure: React.FC<Props> = ({ isFirm, fieldName, formBag, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Custom Disclosure" />

      <Textarea
        {...formBag.register(fieldName)}
        aria-label="Custom disclosure"
        rows={4}
        placeholder="Enter custom disclosure"
        maxLength={750}
        resize="vertical"
        helperText="Max. 750 characters"
      />

      {isFirm && (
        <Toggle {...formBag.register('customDisclosuresEditableByAdviser')} mt="24">
          Allow Advisors to Append Custom Disclosures
        </Toggle>
      )}
    </Box>
  );
};
